import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import cx from 'classnames';
import { marked } from 'marked';
import ReactDOMServer from 'react-dom/server';

import { load as loadHTML } from 'cheerio';

import './ui-markdown.sass';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
}

export function Markdown({ className, text, ...props }: Props) {
  const fullHtml = markedWithExternalLinks(text);

  // NOTE: mt-0 classes on first child headings are there to prevent awkward
  // whitespace above a document / textblock starting with a heading
  const headingClasses = '[&>h1:first-child]:mt-0 [&>h2:first-child]:mt-0 [&>h3:first-child]:mt-0 [&>h4:first-child]:mt-0 [&>h5:first-child]:mt-0 [&>h6:first-child]:mt-0';

  const visibleContentComponent = (
    <div {...props} className={cx('dtMarkdown', headingClasses, className)} dangerouslySetInnerHTML={{ __html: fullHtml }}></div>
  );

  return (
    <>
      {visibleContentComponent}
    </>
  );
}

const markedWithExternalLinks = (text: string) => {
  // This function is a workaround for the marked library not supporting the target attribute for links
  // Whenever a link to an external website is created, the target attribute is added
  const markedText: string = marked(text) as string;
  const $ = loadHTML(markedText);
  const iconString = ReactDOMServer.renderToString(<OpenInNewIcon className="external-link-icon" fontSize="small" />);

  $('a[href^="http"]').attr('target', '_blank').attr('rel', 'noopener noreferrer').after(iconString);

  // on <ol> tags add the tailwind class "list-decimal"
  $('ol').addClass('list-decimal list-outside ml-5');

  // on <ul> tags add the tailwind class "list-disc"
  $('ul').addClass('list-disc list-outside ml-5');

  // style hr tags to be more visible
  $('hr').addClass('border-primary-200 my-4 border-t-4');

  // style headings with proper font sizes and weights
  $('h1').addClass('text-3xl font-bold mb-4 mt-6');
  $('h2').addClass('text-2xl font-semibold mb-3 mt-5');
  $('h3').addClass('text-xl font-semibold mb-2 mt-4');
  $('h4').addClass('text-lg font-medium mb-2 mt-3');
  $('h5').addClass('text-base font-medium mb-1 mt-2');
  $('h6').addClass('text-sm font-medium mb-1 mt-2');

  // $('p').addClass('leading-loose');

  return $.html();
};
